import { useContext } from 'react';
import { AdCampaignsDataContext } from 'src/contexts/AdCampaignsDataContext';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { Content } from 'src/contexts/ContentContext';
import { Button } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import {
  AdCampaignState,
  CampaignManagerClient,
  SponsoredListingsCampaign,
} from 'src/WebApiController';

export type UpdateCampaignStateButtonProps = {
  campaign: SponsoredListingsCampaign;
  state: AdCampaignState;
  onBeforePause?: () => void;
  onAfterPause?: (success: boolean) => void;
  disabled?: boolean;
  className?: string;
};

export const UpdateCampaignStateButton = ({
  campaign,
  state,
  onBeforePause,
  onAfterPause,
  disabled,
  className,
}: UpdateCampaignStateButtonProps) => {
  const { showErrorDialog, genericError } = useClientLogContext();
  const { activeAccountWebClientConfig } = useAppContext();

  const onClickHandler = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    onBeforePause?.();
    await tryInvokeApi(
      async () => {
        if (campaign?.campaignId) {
          const client = new CampaignManagerClient(
            activeAccountWebClientConfig
          );
          const response = await client.updateCampaignState(
            campaign.campaignId,
            state
          );

          if (response.success) {
            onAfterPause?.(true);
          } else {
            showErrorDialog('updateCampaignState', {
              message: response.errorMessage || genericError,
            });
            onAfterPause?.(false);
          }
        }
      },
      (error) => {
        showErrorDialog('updateCampaignState', error);
        onAfterPause?.(false);
      }
    );
  };

  return (
    <Button
      className={className}
      variant="outlineGray"
      shape="rect"
      onClick={onClickHandler}
      disabled={disabled}
    >
      <Content
        id={
          state === AdCampaignState.Paused
            ? ContentId.Pause
            : state === AdCampaignState.Active
              ? ContentId.Restart
              : state === AdCampaignState.Deleted
                ? ContentId.Archive
                : undefined
        }
      />
    </Button>
  );
};
